import { engagementButtonLabel } from "%/dynamic-component-editor/helpers/story-engagement.mjs";
import Prefix from "%/dynamic-component-editor/options/prefix";
import Suffix from "%/dynamic-component-editor/options/suffix";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import DisplayIcon from "%/dynamic-component-editor/options/display-icon";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import {
  TextElementMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/text-element-mixin";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import BorderSides from "%/dynamic-component-editor/options/border-sides";
import DynamicComponentError from "%/dynamic-component-editor/errors/dynamic-component-error";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import IconPosition from "%/dynamic-component-editor/options/icon-position";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import IconColor from "%/dynamic-component-editor/options/icon-color";
import IconSize from "%/dynamic-component-editor/options/icon-size";
import Icon from "%/dynamic-component-editor/options/icon";
import CountSize from "%/dynamic-component-editor/options/count-size";
import CountColor from "%/dynamic-component-editor/options/count-color";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";
import normalizeFontSizeStyleValue from "%/dynamic-component-editor/helpers/font-size-style-value";

export const ActionElementMixin = {
  elementPanelSettings: {
    displayIcon: "hyperlink",
    elementType: "element",
  },
  mixins: [DynamicElementMixin, TextElementMixin],
  props: {
    handleCustomClick: {
      type: Function,
      default: null,
      required: false,
    },
    customValue: {
      type: String,
      default: "",
      required: false,
    },
  },
  options: [
    new LayoutWidth({
      "default": "hug",
    }, true),
    new LayoutHeight({
      "default": "hug",
    }, true),
  ],
  optionBundles: [
    new AppearanceOptions({
      "default.border-radius": "large",
    }, {
      "border-radius": false,
    }),
    ButtonActionOptions,
    AnimationEffectsOptions,
    new SpacingOptions({
      "default.padding": {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
    }),
    new BackgroundOptions({}, {
      "background-image": true,
    }),
    BorderOptions,
  ],
  data() {
    return {
      BasicTextOptions,
      DisplayValue,
      DisplayIcon,
    };
  },
  computed: {
    countPending() {
      return false;
    },
    actionAriaLabel() {
      return engagementButtonLabel(this.$options.actionLabel, this.countPending ? "" : this.myValue);
    },
    myValue() {
      return this.getOptionValue(DisplayValue) === "show" ? this.customValue : "";
    },
    myIcon() {
      return this.getOptionValue(DisplayIcon) === "show" ? this.getOptionValue(Icon) : "";
    },
    isLoading() {
      return false;
    },
    shouldShowAction() {
      return true;
    },
    myIconPosition() {
      return this.getOptionValue(IconPosition);
    },
    // A compiled surface has no value for an option the element never set; no sides means no borders.
    myBorderSides() {
      return this.getOptionValue(BorderSides) || {};
    },
    myPrefix() {
      return this.getOptionValue(Prefix);
    },
    mySuffix() {
      return this.getOptionValue(Suffix);
    },
    myDisplayValue() {
      return this.getOptionValue(DisplayValue);
    },
    myDisplayIcon() {
      return this.getOptionValue(DisplayIcon);
    },
    myIconColor() {
      return this.getOptionValue(IconColor);
    },
    myIconSize() {
      return this.getOptionValue(IconSize);
    },
    myCountColor() {
      return this.getOptionValue(CountColor) || "standard";
    },
    myCountSize() {
      return normalizeFontSizeStyleValue(this.getOptionValue(CountSize), { element: "ActionElement", option: "count-size" });
    },
  },
  methods: {
    handleClick() {
      if (!this.handleCustomClick) {
        throw new DynamicComponentError(
          "click handler must be implemented when using action element",
          {},
        );
      }

      this.handleCustomClick();
    },
  },
};
